<router-outlet></router-outlet>

@if (idleModalVisible()) {
  <div
    class="modal top show"
    style="display: block"
    tabindex="-1"
    role="dialog"
    aria-labelledby="idleModalLabel"
    aria-modal="true"
  >
    <div class="modal-dialog modal-frame modal-top" role="document">
      <div class="modal-content b2-color-delete-reversed">
        <div class="modal-body">
          <h3>Sie sind seit einiger Zeit inaktiv, nach {{ secondsLeft() }}s werden Sie automatisch abgemeldet</h3>
          <div class="progress">
            <div
              class="progress-bar bg-success"
              role="progressbar"
              [style.width.%]="((60 - secondsLeft()) / 60) * 100"
              [attr.aria-valuenow]="secondsLeft()"
              aria-valuemin="0"
              aria-valuemax="60"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
